<template>
  <page-outline :title="$t('pacs003.consult')">
    <template slot="pageContent">
      <!-- FILTRES MOBILE -->
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            propedServiceId="10"
            filterType="list"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter>
        </div>
      </div>
      <div class="listPage" style="overflow: hidden">
        <b-row>
          <b-col cols="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  format="SDD"
                  :mode="this.mode"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="10"
                  :countResults="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br />

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100" />
              </b-col>
            </b-row>

            <br />
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <b-table
                hover
                responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable">
                <template #cell(montantTotal)="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span :title="data.value" :class="data.item.statusClass">{{ data.value }} EUR</span>
                  </div>
                </template>
                <template #cell(processDate)="row_d">
                  {{ row_d.item.processDate }}
                </template>
                <template #cell(nomPacs)="row_e">
                  <!-- <div class="text-left" v-if="(row_e.item.nomPacs.length > 27)">
                    {{ row_e.item.nomPacs.substr(0,27)+ '...' }}
                  </div>
                  <div class="text-left" v-else>{{row_e.item.nomPacs}}</div> -->
                  <div class="text-center">{{row_e.item.nomPacs}}</div>
                </template>
                <!-- <template #cell(holder)="row_h"
                  ><div class="text-left">{{ row_h.item.holder }}</div></template
                >
                <template #cell(contact)="row_c"
                  ><div class="text-left">{{ row_c.item.contact }}</div></template
                > -->
                <!-- <template #cell(status)="row_s"
                  ><div class="text-left">{{ row_s.item.status }}</div></template
                > -->
                <!-- <template #cell(reasonDescription)="row_dt">
                  <div  class="cursor" >{{row_dt.item.reasonDescription}}</div>
                </template> -->
                <template #cell(download)="row_dl">
                  <div @click="downloadPacs(row_dl.item.idPacs)" class="cursor" v-html="row_dl.item.download"></div
                ></template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t("common.no_result") }}
                </span>
              </div>
            </div>

            <b-row class="justify-content-end mt-5">
              <b-col lg="2" offset="7" class="mt-3">
                <b-button variant="primary"
                  @click="downloadList()">
                  <i class="fa-solid fa-arrow-up-from-bracket"></i>
                  {{ $t('pain008.extract_list') }}
                </b-button>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col>
                <b-col>
                  <cm-pagination
                    :maxResultsByPage="paginationObject.maxResults"
                    :firstIndex="paginationObject.firstIndex"
                    :nbResultsTotal="paginationObject.nbResultsTotal"
                    :refreshEvent="paginationObject.refresh">
                  </cm-pagination>
                </b-col>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import pagination from "@/components/common/pagination.vue"
import MessagesFilter from "@/pages/pacs008/components/FilterExit/index.vue"
import { errorMessageAlert } from "@/helpers/alert"

export default {
  name: "Consultation",
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: ['id'],
  computed: {
    isSmartphoneOS() {
      return this.$f7.device.os === "android" || this.$f7.device.os === "ios"
    },
  },
  data() {
    return {
      activateSpinner: false,
      completeList: [],
      countResults: "",
      fields: [
        {
          key: "processDate",
          label: this.$t("pacs008.process_date"),
          class: "text-center",
          sortable: true
        },
        {
          key: "nomPacs",
          label: this.$t("pacs003.file_name_pacs"),
          class: "text-center"
        },
        {
          key: "nbTotalTransactions",
          label: this.$t("pacs008.total_transaction_nb"),
          class: "text-center",
          sortable: true
        },
        {
          key: "holder",
          label: this.$t("pacs008.creditor"),
          class: "text-center",
          sortable: true
        },
        {
          key: "montantTotal",
          label: this.$t("pacs008.total_amount"),
          class: "text-center",
          sortable: true
        },
        {
          key: "contact",
          label: this.$t("pacs008.holder"),
          class: "text-center",
          sortable: true
        },
        {
          key: "statut",
          label: this.$t("pacs008.stat_global"),
          class: "text-center"
        },
        // {
        //   key: "reasonDescription",
        //   label: this.$t("pacs008.reject_reason"),
        //   class: "text-center",
        //   thClass: "w-50",
        //   tdClass: 'text-danger'
        // },
        {
          key: "download",
          label: this.$t("pacs008.download"),
          class: "text-center"
        },
      ],
      filterConditions: {},
      items: [],
      mode: 1,
      paginationObject: {},
      sortBy: '',
      sortDir: false,
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    this.reload = false
    this.paginationObject["firstIndex"] = 1
    this.paginationObject["maxResults"] = 13
    this.paginationObject["nbResultsTotal"] = 0

    this.paginationObject["refresh"] = "consultation-page"
    this.$bus.$off("consultation-page")
    this.$bus.$on("consultation-page", (index) => {
      that.onRefresh(index)
      that.pageCounter = 0
    })

    let that = this

    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    if (this.id === '-1') {
      this.onRefresh()
    } else {
      this.showPacs()
    }
  },
  methods: {
    applyFilter(filterConditions, index = 1) {
      this.filterConditions = filterConditions

      this.reload = true
      if (
        filterConditions.modeFilter !== undefined &&
        filterConditions.modeFilter !== this.mode
      ) {
        this.mode = filterConditions.modeFilter
      }

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0

      this.activateSpinner = true
      this.$engine.pacs008
        .updateSDDOut(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions
        )
        .then((resp) => {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
          this.paginationObject.nbResults = resp.data.Pacs003Out.length
          requests = resp.data.Pacs003Out
          this.updateItems(requests)
          this.updateInbox(requests)
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          this.activateSpinner = false
        })
        .catch((error) => {
          errorMessageAlert(error, this, this.$i18n)
        })
    },
    downloadList() {
      let filterConditions = {}
      if (this.reload) {
        filterConditions =
          this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions =
          this.$engine.pacs008.filter.getDefaultFilter()
      }
      this.$engine.pacs008
        .getPacsOutCsvSDD(filterConditions)
        .then((resp) => {
          let list = {}
          list = resp.data.ExportPacs008Out
          this.updateList(list)
          this.extractData(this.completeList, ".csv")
        })
        .catch((e) => {
          errorMessageAlert(e, this, this.$i18n)
        })
    },
    downloadPacs (id) {
      this.activateSpinner = true
      let idPacs = id

      this.$engine.pacs008.getXMLSDD(
        {idPacs: idPacs}
      ).then( resp => {
        let list = {}
        // l'objet retourné s'appelle pacs008 mais il s'agit bien d'un pacs003 (retour modé)
        list = resp.data.Pacs008.data
        this.updateList(list)
        this.extractData(this.completeList, '.xml')
        this.activateSpinner = false
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractData(completeList, format) {
      this.$f7.showPreloader(this.$i18n.t("common.loading_page_label"))
      let today = moment()
      let downloadLink
      let linkSource
      let fileName
      if (format === ".xml") {
        linkSource = "data:text/xml;charset:utf-8;base64," + this.completeList
        downloadLink = document.createElement("a")
        fileName = "Pacs003_" + today.unix() + ".xml"
      } else {
        let firstLine =
          this.$t("pacs003.file_name_pacs") + ";" +
          this.$t("pacs008.process_date") + ";" +
          this.$t("pacs008.total_transaction_nb") + ";" +
          this.$t("pacs008.debtor_bic") + ";" +
          this.$t("pacs008.total_amount") + ";" +
          this.$t("pacs008.creditor_bic") + ";" +
          this.$t("pacs008.stat_global") + "\r\n"
        let line = atob(this.completeList.data)
        let data = firstLine + line
        linkSource = "data:text/csv;charset:utf-8;base64," + btoa(data)
        downloadLink = document.createElement("a")
        fileName = "Pacs003_" + today.unix() + ".csv"
      }
      this.$f7.hidePreloader()

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onRefresh(index = 1) {
      this.pageCounter = 0
      this.paginationObject["firstIndex"] = index
      this.paginationObject["nbResultsTotal"] = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
      }

      this.$engine.pacs008
        .updateSDDOut(
          this.paginationObject.maxResults,
          this.paginationObject.firstIndex,
          filterConditions,
        )
        .then((resp) => {
          let requests = {}
          this.paginationObject.nbResultsTotal = resp.data.nbTotalResults

          this.paginationObject.nbResults = resp.data.Pacs003Out.length
          requests = resp.data.Pacs003Out

          this.updateItems(requests)
          this.updateInbox(requests)
          this.$f7.pullToRefreshDone()
          this.$bus.emit(
            "refresh-cache-paging-template",
            this.paginationObject
          )
          this.activateSpinner = false
        })
        .catch((error) => {
          this.activateSpinner = false
          errorMessageAlert(error, this, this.$i18n)
        })
    },
    showPacs() {
      this.pageCounter = 0
      this.paginationObject.firstIndex = 1
      this.paginationObject.nbResultsTotal = 1
      this.activateSpinner = true
      let idPacs

      if(this.id !== '-1') {
        idPacs = this.id
      } else {
        idPacs === '-1'
      }

      this.$engine.pacs008
      .updateSDDOut(1, 1, {idPacs: idPacs})
      .then((resp) => {
        let requests = {}
        requests = resp.data.Pacs003Out

        this.updateItems(requests)
        this.updateInbox(requests)
        this.$f7.pullToRefreshDone()
        this.$bus.emit(
          "refresh-cache-paging-template",
          this.paginationObject
        )
        this.activateSpinner = false
      })
      .catch((error) => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateInbox(requests) {
      this.inboxMessages = requests
    },
    updateItems(requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {
        let processDate = ""
        processDate = requests[i].processDate

        if (processDate !== "") {
          processDate = moment(processDate).format("DD/MM/YYYY [à] HH[h]mm")
        } else {
          processDate = "-"
        }

        let status_label = ''
        status_label = requests[i].status
        if (status_label && status_label === "1") {
          status_label = 'Emis'
        } else if (status_label && status_label === "2") {
          status_label = 'Rejeté'
        } else {
          status_label = '-'
        }

        let result = {
          idPacs: requests[i].idPacs,
          processDate: processDate,
          contact: requests[i].contact,
          holder: requests[i].holder,
          currency: requests[i].currency,
          statut: status_label,
          refTransaction: requests[i].refTransaction,
          montantTotal: requests[i].montantTotal,
          nbTotalTransactions: requests[i].nbTotalTransactions,
          download: '<i class="fa-duotone fa-download"></i>',
          nomPacs: requests[i].namePacs,
          // reasonDescription: requests[i].reasonDescription
        }
        this.items.push(result)
      }
    },
    updateList (requests) {
      this.completeList = requests
    }
  },
}
</script>
